import { Observable } from 'rxjs';
import { FeedbackApi, MobileFeedback } from 'src/app/hickory-api';
import { mockHandler } from '../mock.handler';

export class MockFeedbackApi extends FeedbackApi {

  postMobileFeedback(body: MobileFeedback): Observable<any> {
    const response = { feedbackStatus: 'mock feedback status' }
    return mockHandler(response);
  }

}
